<template src="./Add.html"></template>

<script>
// import { showAlert } from "@/utils/helpers";

export default {
  created() {

  },
  computed: {
  },
  data() {
    return {
      paymentAccount: {
        hasReference: false,
      },
    };
  },
  methods: {
    confirm() {
      this.$store
        .dispatch("paymentAccounts/add",  this.paymentAccount )
        .then(() => {
          this.back();
        })
        .catch(() => { });
    },
    allowedDates(val) {
      const today = new Date();
      today.setFullYear(today.getFullYear() - 2);
      const date = new Date(val);
      return date < today;
    },
    back() {
      this.$emit("back");
    },
  },
};
</script>